import { render } from "./Image.vue?vue&type=template&id=15bd0d7a"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"

import "./Image.vue?vue&type=style&index=0&id=15bd0d7a&lang=scss"
script.render = render

export default script